import React, { useEffect, useReducer } from "react";
import Box from "@mui/material/Box";
import { useLazyQuery } from "@apollo/client";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

// Custom.
import Wrapper from "../Content/Wrapper";
import Report from "../Content/Report";
import Row from "../Content/Row";
import Header from "../Content/Header";
import { GET_STATISTICS_TUTOR_CERTIFICATES } from "api";
import { GeneralObject } from "@vocollege/app/dist/global";
import VoLoader from "@vocollege/components/dist/VoLoader";
import Stack from "@mui/material/Stack";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  getStatisticsData,
  getStatisticsDataWithChildren,
  getStatisticsDataForTutorCertificates,
  getStatisticsDataForTutorCertificates2,
  groupTutorCertificatesStatisticsDataBySteps,
  groupTutorCertificatesStatisticsDataBySteps2,
  getStatisticsTotal,
  getTutorCertificateStepTotal,
  getTutorCertificatesStep2ModTotal,
} from "services/Utils";
import { getInitialState } from "./state";
import { orderByField, reducer } from "@vocollege/app/dist/modules/VoHelpers";
import { getStepLabel, getExcelData } from "./Utils";

const StatisticsTutorCertificates: React.FC = () => {
  const [state, dispatch] = useReducer(reducer, getInitialState());

  // Methods.

  const handleHeaderChange = (params: GeneralObject) => {
    dispatch({ key: "headerParams", values: params });
    loadQuery({
      variables: {
        from: params.from,
        to: params.to,
        groupBy: params.groupBy,
      },
    });
  };

  // const getStepLabel = (mod: string) => {
  //   let modString = I18n.get.tutorCertificate.modules.find(
  //     (v: GeneralObject) => v.name === mod
  //   );
  //   return modString?.label || "";
  // };

  const hasStep2Modules = () => {
    return (
      state["step2-mod01"] > 0 ||
      state["step2-mod02"] > 0 ||
      state["step2-mod03"] > 0 ||
      state["step2-mod04"] > 0
    );
  };

  // Api.

  const [loadQuery, { data, loading, variables }] = useLazyQuery(
    GET_STATISTICS_TUTOR_CERTIFICATES,
    {
      fetchPolicy: "network-only",
      onCompleted: (loadedData) => {
        // dispatch({
        //   key: "parsedData",
        //   values: groupTutorCertificatesStatisticsDataBySteps(
        //     getStatisticsDataWithChildren(
        //       loadedData?.certStatisticsTutorCertificates.data,
        //       "region"
        //     )
        //   ),
        // });

        dispatch({
          key: "parsedData2",
          values: groupTutorCertificatesStatisticsDataBySteps2(
            getStatisticsDataForTutorCertificates2(
              loadedData?.certStatisticsTutorCertificates.data
            )
          ),
        });
      },
    }
  );

  // Effects.

  useEffect(() => {
    // dispatch({
    //   values: {
    //     total: getStatisticsTotal(state.parsedData),
    //     totalStep1: getTutorCertificateStepTotal(state.parsedData, "step1"),
    //     totalStep2: getTutorCertificateStepTotal(state.parsedData, "step2"),
    //     totalStep3: getTutorCertificateStepTotal(state.parsedData, "step3"),
    //     totalStep1_2: getTutorCertificateStepTotal(state.parsedData, "step1_2"),
    //   },
    // });
    dispatch({
      values: {
        total: getStatisticsTotal(state.parsedData2),
        totalStep1: getTutorCertificateStepTotal(state.parsedData2, "step1"),
        totalStep2: getTutorCertificateStepTotal(state.parsedData2, "step2"),
        totalStep3: getTutorCertificateStepTotal(state.parsedData2, "step3"),
        totalStep1_2: getTutorCertificateStepTotal(
          state.parsedData2,
          "step1_2"
        ),
        "step2-mod01": getTutorCertificatesStep2ModTotal(
          state.parsedData2,
          "step2-mod01"
        ),
        "step2-mod02": getTutorCertificatesStep2ModTotal(
          state.parsedData2,
          "step2-mod02"
        ),
        "step2-mod03": getTutorCertificatesStep2ModTotal(
          state.parsedData2,
          "step2-mod03"
        ),
        "step2-mod04": getTutorCertificatesStep2ModTotal(
          state.parsedData2,
          "step2-mod04"
        ),
      },
    });

    // console.log("state.parsedData2", state.parsedData2);
  }, [state.parsedData2]);

  useEffect(() => {
    // dispatch({
    //   key: "excelData",
    //   values: getExcelData(data, state.parsedData, variables, state),
    // });
  }, [state.total, data, state, variables]);

  return (
    <Wrapper
      title={I18n.get.tutorCertificate.labels.tutorCertificates}
      hideTitleOnPrint>
      <Header
        filters={["from", "to"]}
        groupBy={["region"]}
        onChange={handleHeaderChange}
        excel={state.excelData}
      />
      {!loading && data && (
        <Box
          sx={{
            mt: 4,
            "@media print": {
              mt: 0,
            },
          }}>
          <Report
            title={I18n.get.tutorCertificate.label}
            date={data?.certStatisticsTutorCertificates.createdAt}
            interval={`${variables?.from} - ${variables?.to}`}
            summary={
              state.parsedData2.length > 0 && (
                <Box>
                  {state.total > 0 && (
                    <Row
                      label={I18n.get.vocertStatistics.total}
                      value={state.total}
                    />
                  )}
                  {state.totalStep1 > 0 && (
                    <Box sx={{ ml: 4 }}>
                      <Row
                        label={I18n.get.vocertStatistics.steps.step1}
                        value={state.totalStep1}
                        size="small"
                      />
                    </Box>
                  )}
                  {state.totalStep1_2 > 0 && (
                    <Box sx={{ ml: 4 }}>
                      <Row
                        label={I18n.get.vocertStatistics.steps.step1_2}
                        value={state.totalStep1_2}
                        size="small"
                      />
                    </Box>
                  )}
                  {state.totalStep2 > 0 && (
                    <Box sx={{ ml: 4 }}>
                      <Row
                        label={I18n.get.vocertStatistics.steps.step2}
                        value={state.totalStep2}
                        size="small"
                      />
                    </Box>
                  )}
                  {state.totalStep3 > 0 && (
                    <Box sx={{ ml: 4 }}>
                      <Row
                        label={I18n.get.vocertStatistics.steps.step3}
                        value={state.totalStep3}
                        size="small"
                      />
                    </Box>
                  )}
                  {hasStep2Modules() && (
                    <>
                      <Typography
                        component="h6"
                        variant="body1"
                        // fontWeight={600}
                        sx={{ ml: 4, mt: 2 }}>
                        {I18n.get.tutorCertificate.labels.step2Modules}
                      </Typography>
                      {state["step2-mod01"] > 0 && (
                        <Box sx={{ ml: 6 }}>
                          <Row
                            label={getStepLabel("step2-mod01")}
                            value={state["step2-mod01"]}
                            size="small"
                          />
                        </Box>
                      )}
                      {state["step2-mod02"] > 0 && (
                        <Box sx={{ ml: 6 }}>
                          <Row
                            label={getStepLabel("step2-mod02")}
                            value={state["step2-mod02"]}
                            size="small"
                          />
                        </Box>
                      )}
                      {state["step2-mod03"] > 0 && (
                        <Box sx={{ ml: 6 }}>
                          <Row
                            label={getStepLabel("step2-mod03")}
                            value={state["step2-mod03"]}
                            size="small"
                          />
                        </Box>
                      )}
                      {state["step2-mod04"] > 0 && (
                        <Box sx={{ ml: 6 }}>
                          <Row
                            label={getStepLabel("step2-mod04")}
                            value={state["step2-mod04"]}
                            size="small"
                          />
                        </Box>
                      )}
                    </>
                  )}
                </Box>
              )
            }>
            <Stack sx={{ mt: 2 }}>
              {state.parsedData2.map((v: any, i: number) => (
                <Box key={i}>
                  <Row label={v.title} value={v.total} />
                  {v.steps.map((v: GeneralObject) => (
                    <Box key={v.step} sx={{ ml: 4 }}>
                      <Row
                        label={I18n.get.vocertStatistics.steps[v.step]}
                        value={v.total}
                        size="small"
                      />
                    </Box>
                  ))}
                  {v.step2 && v.step2.length > 0 && (
                    <Typography
                      component="h6"
                      variant="body1"
                      // fontWeight={600}
                      sx={{ ml: 4, mt: 2 }}>
                      {I18n.get.tutorCertificate.labels.step2Modules}
                    </Typography>
                  )}
                  {v.step2.map((v: GeneralObject) => (
                    <Box key={v.mod} sx={{ ml: 6 }}>
                      <Row
                        label={getStepLabel(v.mod)}
                        value={v.total}
                        size="small"
                      />
                    </Box>
                  ))}

                  <Divider sx={{ ml: 4, mt: 2 }} />

                  {Object.keys(v.children)
                    // .filter((childId: string) => !isNaN(parseInt(childId)))
                    .map((childId: string) => {
                      const noChild = isNaN(parseInt(childId));

                      let title = "";
                      let total = 0;

                      let child: any = null;

                      if (noChild) {
                        title = I18n.get.vocertStatistics.withoutLocalCollege;
                        total = v.children.no_local.total;
                      } else {
                        child = v.children[childId];
                        title = child.title;
                        total = child.total;
                      }

                      // const child = v.children[childId];

                      return (
                        <Box
                          key={childId}
                          sx={(theme) => ({
                            borderBottom: `2px solid ${theme.palette.grey[100]}`,
                            ml: 4,
                            mt: 2,
                            pb: 1,
                            "&:last-child": {
                              borderBottom: "none",
                            },
                          })}>
                          <Row label={title} value={total} size="small" />

                          {child &&
                            Object.keys(child.children)
                              // .filter(
                              //   (educatorId: string) =>
                              //     !isNaN(parseInt(educatorId))
                              // )
                              .map((educatorId: string) => {
                                const noEducator = isNaN(parseInt(educatorId));

                                let title = "";
                                let total = 0;

                                if (noEducator) {
                                  title =
                                    I18n.get.vocertStatistics.withoutEducator;
                                  total = child.children.no_educator.total;
                                } else {
                                  const educator = child.children[educatorId];
                                  title = educator.title;
                                  total = educator.total;
                                }

                                return (
                                  <Box
                                    key={educatorId}
                                    sx={(theme) => ({
                                      borderBottom: `2px solid ${theme.palette.grey[100]}`,
                                      ml: 4,
                                      mt: 2,
                                      pb: 1,
                                      "&:last-child": {
                                        borderBottom: "none",
                                      },
                                    })}>
                                    <Row
                                      label={title}
                                      value={total}
                                      size="small"
                                    />
                                  </Box>
                                );
                              })}
                        </Box>
                      );
                    })}
                </Box>
              ))}
            </Stack>
          </Report>
        </Box>
      )}
      {loading && <VoLoader />}
    </Wrapper>
  );
};

export default StatisticsTutorCertificates;
